export function getAllIndexes(array: any[], search: any): number[] {
  const indexes: number[] = [];

  for (let index = 0; index < array.length; index += 1) {
    if (array[index] === search) {
      indexes.push(index);
    }
  }

  return indexes;
}
